<div
  *ngIf="ionicUpdateErrorFlag && internetConnectedFlag"
  class="ionic-update-error"
>
  {{ "errorMessages.app-did-not-start-properly-please-restart" | translate }}
</div>
